import LazyLoad from 'react-lazyload';
import Button from '@alltrails/shared/denali/components/Button';
import Texture from '@alltrails/shared/denali/components/Texture';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import { LanguageSupportUtil } from 'utils/language_support_util';
import { FormattedMessage, useIntl } from '@alltrails/shared/react-intl';
import useUser from 'hooks/useUser';
import useMobileWidth from 'hooks/useMobileWidth';
import { MEDIA_QUERY_MOBILE_DOWN } from 'utils/constants/breakpoints';
import * as styles from './styles/styles.module.scss';
import logoPlus from './logo_plus.png';
import mobileSrc from './plusUpsellNoAuth-w686.jpg';
import mobileSrcAvif from './plusUpsellNoAuth-w686.avif';
import mobileSrcWebp from './plusUpsellNoAuth-w686.webp';
import webSrc from './plusUpsellNoAuth-w1256.jpg';
import webSrcAvif from './plusUpsellNoAuth-w1256.avif';
import webSrcWebp from './plusUpsellNoAuth-w1256.webp';

export default function PlusUpsellNoAuth() {
  const languageRegionCode = useLanguageRegionCode();
  const user = useUser();
  const intl = useIntl();
  const imageAlt = intl.formatMessage({
    defaultMessage: 'Three images depicting two people on a hill, a person smiling, and bikes on the back of a truck'
  });
  const isMobileView = useMobileWidth();
  const texture = <Texture variant="plus" className={styles.texture} imageSize="cropped" />;

  return (
    <div className={styles.container}>
      <div className={styles.imageAndTextContainer}>
        <div className={styles.imageContainer}>
          <picture>
            <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={mobileSrc} type="image/jpg" />
            <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={mobileSrcAvif} type="image/avif" />
            <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={mobileSrcWebp} type="image/webp" />
            <source srcSet={webSrcAvif} type="image/avif" />
            <source srcSet={webSrcWebp} type="image/webp" />
            <img src={webSrc} alt={imageAlt} className={styles.image} loading="lazy" />
          </picture>
        </div>
        {isMobileView && texture}
        <div className={styles.textContainer}>
          <LazyLoad>
            <img className={styles.logoPlusImage} src={logoPlus} alt="all-trails-plus" />
          </LazyLoad>
          <h2 className={styles.title}>
            <FormattedMessage defaultMessage="More tools for more adventures" />
          </h2>
          <p className={styles.text}>
            <FormattedMessage defaultMessage="With offline maps, wrong-turn alerts, and extra planning features, AllTrails+ helps you make the most of every minute outdoors." />
          </p>
          <div className={styles.buyLink}>
            <Button
              text={
                !user || user.isPromoEligible ? (
                  <FormattedMessage defaultMessage="Try AllTrails+ free" />
                ) : (
                  <FormattedMessage defaultMessage="Buy AllTrails+" />
                )
              }
              linkInfo={{ href: LanguageSupportUtil.wrapUrlSafe('/plus?ref=homepage_pro_proupsellnoauth', languageRegionCode) }}
              testId="try-free-or-buy-plus"
              variant="accent"
              allowWrap
            />
          </div>
        </div>
      </div>
      {!isMobileView && texture}
    </div>
  );
}
